export const SET_PRACTICE_INFO = 'SET_PRACTICE_INFO'
